import styled from "styled-components";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";
import { prop, theme } from "styled-tools";

import vector from "../../Assets/Img/VectorHome1.png";

export const JumbotronStyled = styled.div<{
  $img: string;
  $imageResponsive?: string;
  $heightResponsive?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: end;

  background: url(${vector}), url(${(props) => props.$img});
  background-size: 734px 509.5px, cover;
  background-repeat: no-repeat;
  background-position-x: right;
  background-position-y: bottom;
  position: relative;
  height: 736px;
  max-width: 1440px;
  width: 100%;

  ${mediaQuery[Screen.xs]} {
    display: none;
  }

  ${mediaQuery[Screen.sm]} {
    display: none;
  }

  ${mediaQuery[Screen.md]} {
    display: none;
  }
`;

export const ShadowCapa = styled.div`
  background: ${theme("Black")};
  position: absolute;
  max-height: 140vh;
  opacity: 0.5;
  width: 100%;

  ${mediaQuery[Screen.xs]} {
    height: 700px;
  }

  ${mediaQuery[Screen.sm]} {
    height: 700px;
  }

  ${mediaQuery[Screen.md]} {
    height: 700px;
  }
`;

export const ContentJumbotron = styled.div<{ $align: string }>`
  margin-left: ${(props) => (props.$align === "center" ? "0" : "5%")};
  text-align: ${prop("$align")};
  width: ${(props) => (props.$align !== "center" ? "60%" : "100%")};
  z-index: 2;

  p {
    font-weight: 600;
    padding-bottom: 10px;
  }

  ${mediaQuery[Screen.xs]} {
    display: block;
    margin: 0;
    text-align: center;
    width: 100%;

    p {
      display: block;
    }

    h1 {
      display: none;
    }

    h2 {
      font-size: 24px;
      font-weight: 400;
    }
  }

  ${mediaQuery[Screen.sm]} {
    display: block;
    margin: 0;
    text-align: center;
    width: 100%;

    p {
      display: block;
    }

    h1 {
      display: none;
    }

    h2 {
      font-size: 24px;
      font-weight: 400;
    }
  }

  ${mediaQuery[Screen.md]} {
    display: block;
    margin: 0;
    text-align: center;
    width: 100%;

    p {
      display: block;
    }

    h1 {
      display: none;
    }

    h2 {
      font-size: 24px;
      font-weight: 400;
    }
  }
`;

export const Poligon = styled.div`
  height: 100px;
  width: 250px;
  background: linear-gradient(
    -55deg,
    ${theme("Amaranth_Red")} 30%,
    ${theme("White")} 30%
  );
`;
